export const BASE_HEIGHT_CLASS = 'h-[36px]';
export const BASE_HEIGHT_CELL_CLASS = '[&>.cell]:h-36px';
